import ContainerTypeIcon from '@components/icons/CargoTypeIcons/ContainerIcon';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { calculateCargoForContainer } from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/helpers';
import { ContainerParameters } from '@services/requests/orderService/types';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getPalletDescriptions } from '../helpers';

interface FullResultContainerProps {
  containerParameter: ContainerParameters;
  mainLanguage: string;
  BaseData: RouteWidgetBaseParameters;
  containerIndex: number;
}

function FullResultContainer({
  containerParameter,
  mainLanguage,
  BaseData,
  containerIndex,
}: FullResultContainerProps) {
  const { t } = useTranslation('Common');

  const containerCargoDescription = calculateCargoForContainer(
    BaseData.containers,
    containerParameter,
    mainLanguage
  );

  const palletDescriptions = getPalletDescriptions(
    containerParameter.palletsLoaded,
    BaseData.units,
    mainLanguage,
    t('Common:kg')
  );

  return (
    <div className="selection-result-item">
      <div
        className={clsx('selection-result-item__cargo', {
          'has-pallets': containerParameter.palletsLoaded.length > 0,
        })}
      >
        <div className="selection-result-item__icon">
          <ContainerTypeIcon />
        </div>
        <span className="selection-result-item__title">{containerCargoDescription}</span>
      </div>
      {palletDescriptions.length > 0 && (
        <div className="selection-result-item__pallets">
          <span className="selection-result-item__pallets-title">
            {t('Common:CargoSelection.SelectionDialog.PalletsTitle')}
          </span>
          {palletDescriptions.map((desc, i) => (
            <span
              key={`container-${containerIndex}-pallet-${i}`}
              className="selection-result-item__pallet"
            >
              {desc}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export { FullResultContainer };
